module.exports = __webpack_public_path__ + "img/doc_guide01_1.4de9e67c.png";